"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _objectWithoutProperties = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToasterProvider = ToasterProvider;
exports.useToaster = useToaster;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas/typography");

var _Toaster = require("./Toaster");

var _ToasterMessage = require("./ToasterMessage");

var _components = require("./components");

var _useStack = require("./useStack");

var _core = require("@emotion/core");

var Container = _stylitas.styled.div(_templateObject(), _components.container);

var ToasterContext =
/*#__PURE__*/
_react["default"].createContext();

function ToasterProvider(_ref) {
  var children = _ref.children,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top-right' : _ref$position,
      props = _objectWithoutProperties(_ref, ["children", "position"]);

  var _ref2 = (0, _useStack.useStack)(),
      stack = _ref2.stack,
      push = _ref2.push,
      update = _ref2.update,
      remove = _ref2.remove,
      pause = _ref2.pause,
      resume = _ref2.resume;

  var renderedStack = position.includes('bottom') ? stack.slice().reverse() : stack;
  return (0, _core.jsx)(ToasterContext.Provider, (0, _extends2["default"])({
    value: {
      stack: stack.map(function (_ref3) {
        var id = _ref3.id,
            message = _ref3.message,
            level = _ref3.level,
            delay = _ref3.delay,
            onClose = _ref3.onClose;
        return {
          id: id,
          message: message,
          level: level,
          delay: delay,
          onClose: onClose
        };
      }),
      push: push,
      update: update,
      remove: remove
    }
  }, props), children, (0, _core.jsx)(Container, {
    "data-testid": "toastify container",
    position: position
  }, renderedStack.map(function (_ref4) {
    var level = _ref4.level,
        state = _ref4.state,
        message = _ref4.message,
        id = _ref4.id;
    return (0, _core.jsx)("div", {
      className: state === _useStack.STATES.DELETING ? 'bounce-out' : '',
      key: id
    }, (0, _core.jsx)(_Toaster.Toaster, {
      variant: level,
      key: id,
      onClose: function onClose() {
        return remove(id);
      },
      onMouseEnter: function onMouseEnter() {
        return pause(id);
      },
      onMouseLeave: function onMouseLeave() {
        return resume(id);
      },
      loading: state === _useStack.STATES.LOADING
    }, typeof message === 'string' ? (0, _core.jsx)(_ToasterMessage.ToasterMessage, null, (0, _core.jsx)(_typography.Typography, {
      variant: "support"
    }, message)) : message));
  })));
}

process.env.NODE_ENV !== "production" ? ToasterProvider.propTypes = {
  children: _propTypes.any,
  position: (0, _propTypes.oneOf)(['top-right', 'top-left', 'bottom-left', 'bottom-right'])
} : void 0;

function useToaster() {
  var toastify = (0, _react.useContext)(ToasterContext);

  if (!toastify) {
    throw new Error('Cannot use `useToaster` outside of `ToasterProvider`');
  }

  return toastify;
}